var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-wrap"},[_c('audio',{ref:"audioEl",staticClass:"audios",attrs:{"autoplay":"","playsinline":""},on:{"play":_vm.onPlay,"pouse":_vm.onPause}})])}
var staticRenderFns = []

export { render, staticRenderFns }